@if (product$ | async) { @if (isTile) {
<ish-product-tile />
} @if (isRow) {
<ish-product-row />
} } @if (loading$ | async) {
<ish-loading />
}
